import { httpClient } from './httpClient';

export const fetchPayments = async (companyId) => {
  const response = await httpClient.get(`/payments?company_id=${companyId}`);
  return response.data;
};

export const fetchPaymentStatus = async (sessionId) => {
  const response = await httpClient.get(
    `/payments/status?session_id=${sessionId}`
  );
  return response.data;
};

export const downloadPlanCsv = async (companyId, priceId) => {
  const response = await httpClient.get(
    `/payments/download-plan-csv?company_id=${companyId}&price_id=${priceId}`,
    {
      responseType: 'blob',
    }
  );
  return response.data;
};

export const downloadAllCsv = async (companyId) => {
  const response = await httpClient.get(
    `/payments/download-all-csv?company_id=${companyId}`,
    {
      responseType: 'blob',
    }
  );
  return response.data;
};

export const CancelOriginalPlan = async (priceId) => {
  const response = await httpClient.post('/payments/cancel-original-plan', {
    price_id: priceId,
  });
  return response.data;
};